import * as React from "react";
import { useTranslation } from "react-i18next";
import { durationInSeconds, durationInMinutes } from "util/DateTime";
const ReadableDuration = ({ duration }) => {
  const { t } = useTranslation("common");
  const durationInSec = durationInSeconds(duration);
  const durationInMin = durationInMinutes(duration);
  if (durationInSec < 60) {
    return /* @__PURE__ */ React.createElement("span", null, t("duration.seconds", { count: durationInSec }));
  }
  return /* @__PURE__ */ React.createElement("span", null, t("duration.minutes", { count: durationInMin }));
};
export default ReadableDuration;
